import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { Message } from 'semantic-ui-react';
import GetCertificate from '../../CertificateRequest/GetCertificate';

export default class NewNonCycleStudentCertificate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <div>
                <Fragment>
                    <Message>
                        <p><FormattedMessage id="studentDocuments.nonCycleDocumentsInfoIntro" /></p>
                        <ul>
                            <li><FormattedMessage id="studentDocuments.nonCycleDocumentsInfoBullet1" /></li>
                            <li><FormattedMessage id="studentDocuments.nonCycleDocumentsInfoBullet3" /></li>
                            <li><FormattedMessage id="studentDocuments.nonCycleDocumentsInfoBullet4" /></li>
                        </ul>
                    </Message>
                    <GetCertificate
                        closeGetRequestMode={() => this.setState({
                            getCertificate: false, loading: false, firstName: '', lastName: '', index: '', show: false
                        })}
                        student={this.props.student}
                        studentCertificate
                        nonCycleStudent
                    />
                </Fragment>
            </div>);
    }
}




// WEBPACK FOOTER //
// ./src/views/NonCycleStudent/NonCycleStudentDocuments/NewNonCycleStudentCertificate.js